import React from 'react';

const RobotIcon = () => (
  <svg
    width={17}
    height={17}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth={1.5}
    aria-hidden
    style={{ display: 'block' }}
  >
    <rect height='7.5' width='12.5' y='5.75' x='1.75' />
    <path d='m10.75 8.75v1.5m-5.5-1.5v1.5m-.5-7.5 3.25 3 3.25-3' />
  </svg>
);

export default RobotIcon;
